module.exports = __webpack_public_path__ + "static/media/thumbnail.a8228b7e.jpg";